// src/components/LeftSidebar.jsx
import React, { useState } from 'react';
import '../styles/LeftSidebar.css';
import { useNavigate, useLocation } from 'react-router-dom';
import GlassCard from '../../components/GlassCard';
import { useCurrentLang } from '../../hooks/useCurrentLang';





const monthNamesEN = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];


const weekdaysShortEN = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];


const monthNamesSL = [
  'Januar', 'Februar', 'Marec', 'April', 'Maj', 'Junij',
  'Julij', 'Avgust', 'September', 'Oktober', 'November', 'December'
];

const weekdaysShortSL = ['Po', 'To', 'Sr', 'Če', 'Pe', 'So', 'Ne'];

function getLocaleStrings(lang) {
  const isSlovene = lang === "sl" || lang === "sl_SI";

  return {
    monthNames: isSlovene ? monthNamesSL : monthNamesEN,
    weekdaysShort: isSlovene ? weekdaysShortSL : weekdaysShortEN,
  };
}

function buildMonthDays(year, month) {
  const firstWeekday = new Date(year, month, 1).getDay(); // 0–6, Sun‑based
  const lastDay = new Date(year, month + 1, 0).getDate();
  const lastMonthLastDay = new Date(year, month, 0).getDate();

  const offset = (firstWeekday + 6) % 7; // convert to Monday‑based grid

  const days = [];

  // previous month padding
  for (let i = offset; i > 0; i--) {
    days.push({
      label: lastMonthLastDay - i + 1,
      date: null,
      inactive: true,
    });
  }

  // current month days
  for (let d = 1; d <= lastDay; d++) {
    days.push({
      label: d,
      date: new Date(year, month, d),
      inactive: false,
    });
  }

  // next month padding
  const trailing = (7 - (days.length % 7)) % 7;
  for (let i = 1; i <= trailing; i++) {
    days.push({
      label: i,
      date: null,
      inactive: true,
    });
  }

  return days;
}

export default function LeftSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentLang = useCurrentLang()
  const { monthNames, weekdaysShort } = getLocaleStrings(currentLang);

  const today = new Date();
  const [viewDate, setViewDate] = useState(
    new Date(today.getFullYear(), today.getMonth(), 1)
  );
  const [selectedDate, setSelectedDate] = useState(null);

  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();
  const days = buildMonthDays(year, month);

  const handleMonthChange = (delta) => {
    setViewDate((prev) => {
      const next = new Date(prev);
      next.setMonth(prev.getMonth() + delta);
      return new Date(next.getFullYear(), next.getMonth(), 1);
    });
    setSelectedDate(null);
  };

  const handleDayClick = (day) => {
    if (!day.date) return;
    setSelectedDate(day.date);

    const y = day.date.getFullYear();
    const m = String(day.date.getMonth() + 1).padStart(2, '0');
    const d = String(day.date.getDate()).padStart(2, '0');

    //! adjust to your route
    navigate(`/${currentLang}/platform/sessions?date=${y}-${m}-${d}`);
  };

  const isSameDay = (d1, d2) =>
    d1 &&
    d2 &&
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();

  const menuItems = [
    { label: {en: 'My Profile', sl: "Moj profil"}, path: `/${currentLang}/platform/user-profile` },
    { label: {en: 'Edit My Plan', sl: "Spremeni načrt"}, path: `/${currentLang}/platform/edit-plan` },
    { label: {en:"Today's Sessions", sl: "Današnje vadbe"}, path: `/${currentLang}/platform/todays-sessions` },
    { label: {en: 'Unknown Exercises', sl: "Neznane vaje"}, path: `/${currentLang}/platform/unknown-exercises` },
    { label: {en: 'My History', sl: "Zgodovina"}, path: `/${currentLang}/platform/history` },
  ];

  return (
    <aside className="revimo-sidebar">
      <GlassCard style={{padding: "15px",  marginBottom: "15px"}} >
        <nav className="sidebar-menu">
          {menuItems.map((item) => (
            <button
              key={item.path}
              className={
                'sidebar-pill' +
                (location.pathname === item.path ? ' active' : '')
              }
              onClick={() => navigate(item.path)}
            >
              {item.label[currentLang]}
            </button>
          ))}
        </nav>
      </GlassCard>

      <GlassCard style={{padding: "15px"}}>
        <section className="calendar">
          <header className="calendar-header">
            <button
              className="calendar-nav"
              onClick={() => handleMonthChange(-1)}
            >
              &#8249;
            </button>
            <div className="calendar-current-date">
              {monthNames[month]} {year}
            </div>
            <button
              className="calendar-nav"
              onClick={() => handleMonthChange(1)}
            >
              &#8250;
            </button>
          </header>

          <ul className="calendar-weekdays">
            {weekdaysShort.map((w) => (
              <li key={w}>{w}</li>
            ))}
          </ul>

          <ul className="calendar-dates">
            {days.map((day, idx) => {
              const isToday =
                !day.inactive && isSameDay(day.date, today);
              const isSelected =
                !day.inactive && isSameDay(day.date, selectedDate);

              let cls = 'calendar-day';
              if (day.inactive) cls += ' inactive';
              if (isToday) cls += ' today';
              if (isSelected) cls += ' selected';

              return (
                <li
                  key={idx}
                  className={cls}
                  onClick={() => handleDayClick(day)}
                >
                  {day.label}
                </li>
              );
            })}
          </ul>
        </section>
      </GlassCard>
    </aside>
  );
}
